import { render, staticRenderFns } from "./UserFarmRequest.vue?vue&type=template&id=2657fa1a&scoped=true"
import script from "./UserFarmRequest.vue?vue&type=script&lang=js"
export * from "./UserFarmRequest.vue?vue&type=script&lang=js"
import style0 from "./UserFarmRequest.vue?vue&type=style&index=0&id=2657fa1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2657fa1a",
  null
  
)

export default component.exports